import { getCookieByName } from './getCookieByName';

export const getChannelNameFromCookie = () => getCookieByName('mz-channel-domain');
